import { useState } from 'react';

// mappingPreview: { mapping, unmatched_headers, unresolved_required, target_fields, source }
// headers: full list of raw source headers from the file
export default function ColumnMappingGrid({ mappingPreview, headers, onConfirm, onCancel, submitting }) {
  const [picks, setPicks] = useState({}); // target_field -> header
  const [saveAsDefault, setSaveAsDefault] = useState(true);

  const allResolved = mappingPreview.unresolved_required.every(f => picks[f]);

  const confirm = () => {
    const manualMapping = {};
    for (const [field, header] of Object.entries(picks)) {
      if (header) manualMapping[header] = field;
    }
    onConfirm(manualMapping, saveAsDefault);
  };

  return (
    <div>
      <p style={{ fontSize: 12, color: '#8C94A0', marginBottom: 12 }}>
        {mappingPreview.source === 'builtin'
          ? "This file's headers didn't fully match the built-in Statex format — map the remaining required fields below."
          : "Some columns didn't match this client's saved mapping — map the remaining required fields below."}
      </p>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, marginBottom: 12 }}>
        <thead>
          <tr style={{ textAlign: 'left', color: '#8C94A0', textTransform: 'uppercase', fontSize: 10 }}>
            <th style={{ padding: '6px 8px' }}>Required field</th>
            <th style={{ padding: '6px 8px' }}>Source column</th>
          </tr>
        </thead>
        <tbody>
          {mappingPreview.unresolved_required.map(field => (
            <tr key={field} style={{ borderTop: '1px solid #E3E2DD' }}>
              <td style={{ padding: '6px 8px' }}>{mappingPreview.target_fields[field] || field}</td>
              <td style={{ padding: '6px 8px' }}>
                <select
                  value={picks[field] || ''}
                  onChange={e => setPicks(p => ({ ...p, [field]: e.target.value }))}
                  style={{ background: '#F5F5F2', color: '#171A1F', border: '1px solid #E3E2DD', borderRadius: 8, padding: '4px 8px', fontSize: 12, width: '100%' }}
                >
                  <option value="">— select column —</option>
                  {headers.map(h => <option key={h} value={h}>{h}</option>)}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#8C94A0', marginBottom: 14 }}>
        <input type="checkbox" checked={saveAsDefault} onChange={e => setSaveAsDefault(e.target.checked)} />
        Save this mapping as the default for this client, for future Statex imports
      </label>

      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={confirm} disabled={!allResolved || submitting} style={{
          background: '#171A1F', color: '#F5F5F2', border: 'none', borderRadius: 8,
          padding: '7px 18px', fontSize: 12, fontWeight: 700, cursor: 'pointer',
          opacity: (!allResolved || submitting) ? 0.5 : 1,
        }}>{submitting ? 'Importing…' : 'Continue import'}</button>
        <button onClick={onCancel} disabled={submitting} style={{
          background: 'transparent', color: '#8C94A0', border: '1px solid #E3E2DD', borderRadius: 8,
          padding: '7px 18px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
        }}>Cancel</button>
      </div>
    </div>
  );
}
